import * as React from 'react';

import * as styles from './styles.css';
import { Spinner } from '@cian/ui-kit';

export const ModalLoader: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <div data-testid="loader" className={styles['wrapper']}>
      <Spinner size={16} />
    </div>
  );
};

ModalLoader.displayName = 'ModalLoader';
